import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Error from '@mui/icons-material/Error';

import {
  blue500,
  blueBlack700,
  blueUltramarine100,
  blueUltramarine200,
} from '../../../../../../../theme/videa-style-tokens';

export const CornerstoneElement = styled.div<{
  activeImage?: boolean;
  selectedPhoto?: boolean;
}>`
  .user-circle,
  .user-arrow,
  .user-polyline {
    stroke: ${blue500};
  }
  &.expanded {
    width: 100%;
    max-width: 540px;
    height: 100%;
    max-height: 450px;
  }
  &.not-expanded {
    width: 90px;
    height: 75px;
    &.sidebar-redesign {
      width: 70px;
      height: 60px;
    }
  }
  display: flex;
  position: relative;
  .default {
    cursor: pointer !important;
    &.user-annotation {
      cursor: crosshair !important;
    }
  }
  :focus-visible {
    // This style prevents the last clicked image from retaining an outline
    // after the user changes the selected image using the arrow keys.
    outline: none;
  }
  border: 0.125em solid transparent;
  border-radius: 0.5em;
  overflow: hidden;
  padding: 0.125em;
  ${({ activeImage }) =>
    activeImage &&
    css`
      color: white;
      border-color: ${blueUltramarine100};
    `}
  ${({ selectedPhoto }) =>
    selectedPhoto &&
    css`
      color: white;
      border-color: ${blueUltramarine200};
    `}
  .fmx {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3em;
    border-radius: 0.5em;
    opacity: 0.5;
    background-color: black;
    position: absolute;
    z-index: 100;
    bottom: 0;
    left: 0;
    .fmx-icon {
      width: 2em;
      .icon-shape {
        fill: white;
      }
    }
  }
`;

export const ImageContainer = styled.div<{
  isDraggingOver: boolean;
  isDragging: boolean;
}>`
  position: relative;
  height: 100%;
  margin: 0.2em;
  .close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    background-color: ${blueUltramarine200};
    position: absolute;
    z-index: 100;
    top: -0.25em;
    right: -0.25em;
    .close-icon {
      opacity: 1;
      width: 0.625em;
      fill: ${blueBlack700};
    }
  }
  ${({ isDragging }) =>
    isDragging &&
    css`
      &::after {
        content: '';
        position: absolute;
        background-color: transparent;
        z-index: 20;
        top: 10%;
        left: 9%;
        width: 78%;
        height: 70%;
        border: 5px dashed rgba(155, 155, 155, 0.5);
        border-radius: 16px;
      }
      &::before {
        content: '';
        position: absolute;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `}
  ${({ isDraggingOver }) =>
    isDraggingOver &&
    css`
      &::after {
        z-index: 30;
        border-color: white;
      }
    `}
`;

export const LoadingSpinnerAdditionalImage = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  justify-content: center;
`;

export const ErrorIcon = styled(Error)`
  color: red;
  position: absolute;
  z-index: 12;
`;
